import { Controller } from "@hotwired/stimulus"
import * as prismic from "@prismicio/client"

const endpoint = prismic.getRepositoryEndpoint("marmosetmusic")
const client = prismic.createClient(endpoint, {
  accessToken: process.env.PRISMIC_ACCESS_TOKEN,
})

export default class extends Controller {
  static values = {
    pageId: String,
  }

  async connect() {
    let pageId = window.pageId
    if (!pageId) {
      pageId = await this.getHomePageIdFallback()
    }

    if (!pageId) return
    this.loadPrismicData(pageId)
  }

  async getHomePageIdFallback() {
    try {
      const doc = await client.getByUID('home_page', 'home')
      if (doc?.id) return doc.id
    } catch (error) {
      console.warn("Could not fetch home page from Prismic.", error)
    }
    return null
  }

  async loadPrismicData(pageId) {
    try {
      const doc = await client.getByID(pageId)
      const slice = doc?.data?.body?.find((s) => s.slice_type === "email_sign_up_form")

      if (!slice) return

      this.listId = slice.primary.mailchimp_audience_id
      this.buttonText = slice.primary.button_text

      const btn = this.element.querySelector("button[type='submit']")
      if (btn && this.buttonText && btn.innerText.trim() === "") {
        btn.innerText = this.buttonText
      }
    } catch (error) {
      console.error("Error fetching Prismic in Stimulus controller:", error)
    }
  }

  submit(event) {
    event.preventDefault()

    const form = event.target
    const firstNameInput = form.querySelector("[name='first_name']")
    const emailInput = form.querySelector("[name='email']")
    const button = form.querySelector("button[type='submit']")
    const messageContainer = this.element.querySelector(".newsletter-status-message")

    if (!emailInput || !messageContainer || !button) return
    if (!this.listId) {
      this.showMessage(messageContainer, button, "error", "Something went wrong. Please try again later.")
      return
    }

    const firstName = firstNameInput?.value || ""
    const email = emailInput.value

    button.disabled = true

    this.subscribe(firstName, email)
      .then((success) => {

        const type = success ? "success" : "error"
        const text = success
          ? "Success! You're now subscribed."
          : "Something went wrong. Please try again."

        this.showMessage(messageContainer, button, type, text, () => {
          if (success) {
            if (firstNameInput) firstNameInput.value = ""
            emailInput.value = ""
          }
        })
      })
      .catch((error) => {
        console.error(error)
        this.showMessage(messageContainer, button, "error", "Unexpected error. Please try again later.")
      })
  }

  async subscribe(firstName, email) {
    const response = await fetch("/api/graphql", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
      },
      body: JSON.stringify({
        query: `
          mutation SubscribeToEmailList(
            $firstName: String!,
            $email: String!,
            $listId: String!,
            $source: String!
          ) {
            subscribeToEmailList(
              firstName: $firstName,
              email: $email,
              listId: $listId,
              source: $source
            ) {
              success
            }
          }
        `,
        variables: {
          firstName,
          email,
          listId: this.listId,
          source: "guide",
        },
      }),
    })

    const data = await response.json()
    return data?.data?.subscribeToEmailList?.success || false
  }

  showMessage(container, button, type, text, callback = () => {}) {
    container.innerHTML = `
      <div class="newsletter-message-box ${type}">
        ${text}
      </div>
    `

    setTimeout(() => {
      container.innerHTML = ""
      button.disabled = false
      callback()
    }, 5000)
  }
}
